"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfraError = void 0;
const baseError_1 = require("../baseError");
class InfraError extends baseError_1.BaseError {
    constructor(message, code) {
        super(message);
        this.code = code;
    }
}
exports.InfraError = InfraError;
//# sourceMappingURL=infraError.js.map